<template>
  <div>
    <div
      v-if="showLoader"
      class="spinner-border"
      style="margin:auto;display:block;"
    ></div>
    <form v-else v-on:submit.prevent class="main_form_block">
      <div style="border:1px #e2e2e2 solid; padding:20px" class="col-sm-11">
        <div v-if="showisVendorList && vendorDropDownList" class="form-group row">
          <div class="col-sm-12">
            <CampaignFormDropDown
              ref="multiselectRef"
              :isVendor="showVendor"
              label="Vendor"
              selection="Vendor Selection"
              @showNextView="showBrandFormView"
              isMultiSelect="false"
              :vendorVal="vendor_id"
              :nonEditable="isEditCampaignPage && vendor_id ? true : false"
              :mandatory="true"
              :vendor_name="vendor_name"
              :dataLoading="showVendorLoader"
              :dropdownList="vendorDropDownList"
              :selectedValue="vendor_id"
              :selectedList="[]"
              placeholder="Vendor"
            />
          </div>
        </div>
        <div
          v-if="showisBrandsList && brandDropDownList"
          class="form-group row"
        >
          <div class="col-sm-12">
            <CampaignFormDropDown
              ref="multiselectRefBrand"
              :fromBrandData="true"
              :isBrand="showisBrandsList"
              label="Brand"
              selection="Brand Selection"
              @showNextView="showProductsFormView"
              :mandatory="true"
              isMultiSelect="false"
              :brandVal="ams_profile_id"
              :nonEditable="
                (isEditCampaignPage && isAmsProfile) ||
                  ($route.params.products && isAmsProfile) ||
                  amsCampaignIdFetched
              "
              :brand_name="brand_name"
              :dataLoading="showBrandLoader"
              :dropdownList="brandDropDownList"
              :selectedValue="ams_profile_id"
              :selectedList="[]"
              placeholder="Brand"
            />
          </div>
        </div>
        <!-- <div v-if="showisProductList">
          <CampaignFormDropDown
            ref="multiselectRef"
            :isProduct="showisProductList"
            label="Product"
            selection="Product Selection"
            @showNextView="showRemainingFormView"
            isMultiSelect="true"
            :productVal="productList"
            :dataLoading="showProductLoader"
            :dropdownList="productDropDownList"
            :selectedValue="''"
            :selectedList="productList"
            :nonEditable="amsCampaignIdFetched"
            placeholder="Product"
          />
        </div> -->
        <div
          v-if="!showRemainingForm && showRemainingLoader"
          class="spinner-border"
          style="margin:auto;display:block;margin-top:60px"
        ></div>
        <div v-if="showRemainingForm">
          <!-- <div class="form-group row" v-if="productList && productList.length > 0">
							<label for="asinNo" class="col-sm-2 col-form-label" v-if="$route.params.campaignId">ASIN</label>
							<label class="col-sm-2 col-form-label" v-else></label>
							<div class="col-sm-5">
								<ProductListChipView :productList="productList"></ProductListChipView>
							</div>
						</div>-->
          <div class="form-group row">
            <label for="campaignName" class="col-sm-2 col-form-label">
              Name
              <sup>*</sup>
            </label>
            <div class="col-sm-5">
              <input
                type="text"
                v-model="campaignName"
                class="form-control"
                id="campaignName"
                :class="{ 'is-invalid': submitted && !checkCampaignName }"
                :disabled="amsCampaignIdFetched"
                v-on:keydown="stopRoute"
                autocomplete="off"
                placeholder="Name"
                style="padding-left:8px"
              />
              <span
                v-if="submitted && !checkCampaignName"
                class="invalid-feedback"
                >This field is required</span
              >
            </div>
          </div>

          <!-- <div v-else class="form-group row">
							<label class="col-sm-2 col-form-label">Products</label>
							<div class="col-sm-5">
								<select class="form-control" v-model="productDataList">
									<option :value="0">Product Selection</option>
									<option v-for="item in productListToAdd" :key="item.asin" :value="item.asin"> {{ item.product_title }}</option>
								</select>
							</div>
						</div>-->
          <div class="form-group row campaign-tags-add" v-if="!$store.state.isUserPrestige">
            <label for="tags" class="col-sm-2 col-form-label">Tags</label>
            <div
              class="col-sm-5"
              style="text-transform:capitalize"
              autocomplete="off"
            >
              <!-- <input type="text" v-model="campaignTags"  :disabled="amsCampaignIdFetched" class="form-control" id="tags"> -->
              <multiselect
                v-model="campaignTags"
                :options="campTagsList"
                :searchable="true"
                :loading="tagSearchLoader"
                ref="multiselect"
                label="title"
                track-by="title"
                @tag="addTagsGroup"
                @select="selectTagFromList"
                open-direction="bottom"
                :taggable="true"
                placeholder="Tags"
                class="form-control multi-dropdown col-md-12 select_filter"
                style=""
                :multiple="true"
                id="campaignTags"
                :disabled="amsCampaignIdFetched"
                :closeOnSelect="false" 
              >
              </multiselect>
            </div>
          </div>
          <PrestigeEditCampaignTag v-if="$store.state.isUserPrestige" :tags="prestigeTags" ref="editPrestigeTag"/>
          <CampaignFormDropDown
            label="Campaign Type"
            ref="selectCampaignType"
            selection="Select campaign type"
            isMultiSelect="false"
            :dataLoading="false"
            :dropdownList="campaignTypeList"
            :selectedValue="campaignType"
            :selectedList="[]"
            @showNextView="setCampaignType"
            :nonEditable="amsCampaignIdFetched || isEditCampaignPage"
            :mandatory="true"
            :isCampaignType="true"
            placeholder="Campaign Type"
          />
          <span v-if="submitted && !campaignType" class="invalid-feedback"
            >This field is required</span
          >
          <CampaignFormDropDown
            label="Status"
            ref="selectState"
            selection="Select state"
            isMultiSelect="false"
            :dataLoading="false"
            :dropdownList="statusList"
            :selectedValue="state"
            :selectedList="[]"
            @showNextView="setState"
            :nonEditable="amsCampaignIdFetched"
            :mandatory="true"
            :isStateType="true"
            placeholder="Status"
          />

          <div class="form-group row">
            <label for="dailyBudget" class="col-sm-2 col-form-label"
              >Daily Budget <sup>*</sup></label
            >

            <div class="col-sm-5">
              <input
                placeholder="Daily budget"
                type="number"
                v-model="dailyBudget"
                class="form-control"
                :class="{ 'is-invalid': submitted && !dailyBudget }"
                v-on:keydown="stopRoute"
                id="dailyBudget"
                :disabled="amsCampaignIdFetched || isEditCampaignPage"
                autocomplete="off"
              />
              <span v-if="submitted && !dailyBudget" class="invalid-feedback"
                >This field is required</span
              >
            </div>
          </div>
          <div class="form-group row">
            <label for="tags" class="col-sm-2 col-form-label">
              Duration
              <sup>*</sup>
            </label>
            <div
              class="col-sm-10"
              v-if="!isEditCampaignPage || $route.params.products"
            >
              <div class="row">
                <div class="col-sm-3">
                  <div class="form-check" style="margin-top:7px;">
                    <input
                      v-model="campaignDuration"
                      class="form-check-input"
                      type="radio"
                      name="Duration"
                      id="Duration1"
                      value="option1"
                      @change="checkForDuration"
                      :disabled="amsCampaignIdFetched"
                      checked
                      autocomplete="off"
                    />
                    <label
                      class="form-check-label"
                      for="Duration1"
                      style="vertical-align: middle !important;"
                      >Run Continously Starting Today</label
                    >
                  </div>
                </div>
                <div class="col-sm-9">
                  <div class="form-group row">
                    <div class="form-check col-sm-2" style="margin-top:7px;">
                      <input
                        v-model="campaignDuration"
                        class="form-check-input"
                        type="radio"
                        name="Duration"
                        id="Duration2"
                        value="option2"
                        @change="checkForDuration"
                        :disabled="amsCampaignIdFetched"
                        autocomplete="off"
                      />
                      <label
                        class="form-check-label"
                        for="Duration2"
                        style="vertical-align: middle !important;"
                        >Select Date Range</label
                      >
                    </div>
                    <div
                      class="col-sm-5 row"
                      v-if="campaignDuration == 'option2'"
                    >
                      <div class="col-sm-3 pt-2">
                        <p style="text-align:right">Start Date</p>
                      </div>
                      <div class="col-sm-8">
                        <b-form-datepicker
                          placeholder="MM/DD/YYYY"
                          class="date_wrapper padding-custom"
                          v-model="campaignStartDate"
                          menu-class="w-100"
                          size="sm"
                          :date-format-options="{
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                          }"
                          calendar-width="220%"
                          :hide-header="true"
                          :today-button="false"
                          :min="todaysDate"
                          v-bind:disabled="amsCampaignIdFetched"
                          v-bind:class="
                            amsCampaignIdFetched ? 'date-disabled' : ''
                          "
                          @input="resetCampEndDate"
                          locale="en"
                        ></b-form-datepicker>
                      </div>
                      <!-- <input

													v-model="campaignStartDate"
													:min="todaysDate"
													class="form-control d-inline-block mb-1"
													type="date"
													:disabled="amsCampaignIdFetched"
													autocomplete = "off"
													onkeydown="return false"
													@change="resetCampEndDate"
												> -->
                    </div>
                    <div
                      class="col-sm-5 row"
                      v-if="campaignDuration == 'option2'"
                      style="margin-left:-50px"
                    >
                      <div class="col-sm-3 pt-2">
                        <p style="text-align:right">End Date</p>
                      </div>
                      <div class="col-sm-8">
                        <b-form-datepicker
                          placeholder="MM/DD/YYYY"
                          class="date_wrapper padding-custom"
                          v-model="campaignEndDate"
                          menu-class="w-100"
                          size="sm"
                          :date-format-options="{
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                          }"
                          calendar-width="200%"
                          :hide-header="true"
                          :today-button="false"
                          :min="campaignStartDate"
                          v-bind:disabled="
                            (campaignStartDate == '' ? true : false) ||
                              amsCampaignIdFetched
                          "
                          v-bind:class="
                            amsCampaignIdFetched || campaignStartDate == ''
                              ? 'date-disabled'
                              : ''
                          "
                          locale="en"
                        ></b-form-datepicker>
                      </div>
                      <!-- <input
													style="width:175px;"
													v-model="campaignEndDate"
													:min="campaignStartDate"
													v-bind:disabled="((campaignStartDate == '' ? true : false) ||amsCampaignIdFetched )"
													class="form-control d-inline-block"
													type="date"
													autocomplete = "off"
													onkeydown="return false"
												> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="col-sm-7"
              v-if="isEditCampaignPage && !$route.params.products"
            >
              <!-- <div class="form-check d-inline-block" style="margin-top:7px;">
									<input v-model="campaignDuration" class="form-check-input" type="radio" name="Duration" id="Duration2" value="option2"  @change="checkForDuration">
									<label class="form-check-label" for="Duration2">
										Select Date Range
									</label>
								</div>-->

              <div class="form-group row">
                <div class="col-sm-5 row">
                  <div class="col-sm-3 mt-1">
                    <p>Start Date</p>
                  </div>
                  <div class="col-sm-8">
                    <b-form-datepicker
                      placeholder="MM/DD/YYYY"
                      class="date_wrapper padding-custom"
                      v-model="campaignStartDate"
                      menu-class="w-100"
                      size="sm"
                      :date-format-options="{
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      }"
                      calendar-width="220%"
                      :hide-header="true"
                      :today-button="false"
                      :min="todaysDateEditCampaign"
                      v-bind:disabled="amsCampaignIdFetched"
                      v-bind:class="amsCampaignIdFetched ? 'date-disabled' : ''"
                      @input="resetCampEndDate"
                      locale="en"
                    ></b-form-datepicker>
                  </div>
                </div>
                <!-- <input
											style="width:175px;"
											v-model="campaignStartDate"
											:min="todaysDateEditCampaign"
											class="form-control d-inline-block mb-1"
											type="date"
											:disabled="amsCampaignIdFetched"
											autocomplete = "off"
											onkeydown="return false"
											@change="resetCampEndDate"
										> -->
                <div class="col-sm-5 row" style="margin-left:-50px">
                  <div class="mt-1 col-sm-3">
                    <p>End Date</p>
                  </div>
                  <div class="col-sm-8">
                    <b-form-datepicker
                      placeholder="MM/DD/YYYY"
                      class="date_wrapper padding-custom"
                      v-model="campaignEndDate"
                      menu-class="w-100"
                      size="sm"
                      :date-format-options="{
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                      }"
                      calendar-width="200%"
                      :hide-header="true"
                      :today-button="false"
                      :min="minEndDate"
                      v-bind:disabled="
                        (campaignStartDate == '' ? true : false) ||
                          amsCampaignIdFetched
                      "
                      v-bind:class="
                        amsCampaignIdFetched || campaignStartDate == ''
                          ? 'date-disabled'
                          : ''
                      "
                      locale="en"
                    ></b-form-datepicker>
                    <!-- <input
												style="width:175px;"
												v-model="campaignEndDate"
												:min="campaignStartDate"
												class="form-control d-inline-block"
												type="date"
												autocomplete = "off"
												onkeydown="return false"
												v-bind:disabled="((campaignStartDate == '' ? true : false) ||amsCampaignIdFetched )"
											> -->
                  </div>
                </div>
                <span
                  v-if="
                    !(this.campaignEndDate && this.campaignEndDate.length > 0)
                  "
                  class="ml-2 mt-1"
                  >(This is a never ending campaign)</span
                >
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="tags" class="col-sm-2 col-form-label">
              Targeting Type
              <sup>*</sup>
            </label>
            <div class="col-sm-7">
              <div class="form-check d-inline-block">
                <input
                  class="form-check-input"
                  v-model="campaignTargetType"
                  type="radio"
                  name="TargetingType"
                  id="TargetingType1"
                  value="auto"
                  :disabled="amsCampaignIdFetched"
                  autocomplete="off"
                />
                <label
                  class="form-check-label"
                  for="TargetingType1"
                  style="vertical-align: middle !important;"
                  >Auto</label
                >
              </div>
              <div class="form-check d-inline-block ml-3">
                <input
                  class="form-check-input"
                  v-model="campaignTargetType"
                  type="radio"
                  name="TargetingType"
                  id="TargetingType2"
                  value="manual"
                  :disabled="amsCampaignIdFetched"
                  autocomplete="off"
                />
                <label
                  class="form-check-label"
                  for="TargetingType2"
                  style="vertical-align: middle !important;"
                  >Manual</label
                >
              </div>
            </div>
          </div>
          <div class="form-group row">
            <label for="tags" class="col-sm-2 col-form-label">
              Campaign Group
              <!-- <sup>*</sup> -->
            </label>
            <div class="col-sm-5 campaign-tags-add">
              <!-- <select
									class="form-control"
									v-model="campaignGroup"
									:class="{ 'is-invalid': submitted && !checkCampaignGroupName }"
									:disabled="amsCampaignIdFetched"
									label="Select campaign group"
								>
									<option :value="0">Campaign Group Selection</option>
									<option value="1">Orphan</option>
									<option
										v-for="item in campaignGroupFilterList"
										:key="item.id"
										:value="item.id"
										id="campaignGroup"
									>{{ item.name }}</option>
								</select> -->
              <multiselect
                v-model="campaignGroupObj"
                :options="
                  (campaignGroupFilterList || []).length > 0
                    ? campaignGroupFilterList
                    : [defaultCampGrpObj]
                "
                :searchable="true"
                placeholder="Campaign Group"
                track-by="id"
                label="name"
                open-direction="bottom"
                class="form-control multi-dropdown col-md-12 select_filter"
                :multiple="false"
                :class="{
                  'is-invalid': submitted && !checkCampaignGroupName,
                }"
                :disabled="amsCampaignIdFetched"
                @select="setCampGrpId"
                @remove="removeCampGrpId"
              >
              </multiselect>
              <span
                v-if="submitted && !checkCampaignGroupName"
                class="invalid-feedback"
                >This field is required</span
              >
            </div>
          </div>
          <div
            class="row mt-3 mb-3"
            v-if="
              !isEditCampaignPage &&
                campaignTargetType != 'auto' &&
                amsCampaignIdFetched
            "
          >
            <div class="col-sm-12">
              <div class="wrap row">
                <div class="col-sm-2">
                  <strong>&nbsp;</strong>
                </div>
                <div
                  class="col-sm-2 text-left mb-2"
                  v-if="campaignType == 'sponsoredProducts'"
                  style="padding-right:0px"
                >
                  <button
                    class="btn btn-primary"
                    data-toggle="modal"
                    data-target="#addKeywords"
                    @click="fetchKeywords"
                    style="margin-left: 0px !important;"
                    v-if="ams_campaign_id"
                  >
                    Add Keywords
                  </button>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <button
                style="margin-left: 30px !important;"
                class="btn btn-primary"
                @click="goToCampaignListPage()"
              >
                Exit
              </button>
            </div>
          </div>
          <div v-else>
            <div
              class="row mt-3 mb-3"
              v-show="showRemainingForm && isEditCampaignPage"
            >
              <div
                v-if="
                  campaignTargetType != 'auto' &&
                    campaignType == 'sponsoredProducts'
                "
                class="col-sm-12"
              >
                <div class="wrap row">
                  <div class="col-sm-2">
                    <strong>&nbsp;</strong>
                  </div>
                  <div
                    class="col-sm-2 text-left mb-2"
                    style="padding-right:0px"
                  >
                    <button
                      class="btn btn-primary"
                      data-toggle="modal"
                      data-target="#addKeywords"
                      @click="fetchKeywords"
                      style="margin-left: 0px !important;"
                      v-if="ams_campaign_id"
                    >
                      Add Keywords
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group row">
              <button class="btn btn-secondary" @click="navigateToListPage()">
                Cancel
              </button>
              <button class="btn btn-primary" @click="saveCampaign()">
                {{ isEditCampaignPage ? "Save" : "Save & Next" }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- <AddCampaignKeywordGrid
				:keywordList="keywordList"
				@saveCampaign="saveCampaign"
				@editSelectedKeyword="editSelectedKeyword"
				@deleteSelectedKeyword="deleteSelectedKeyword"
				v-if="showRemainingForm"
				:campaignTargetType="campaignTargetType"
			></AddCampaignKeywordGrid>-->

    <!-- <AddCampaignKeywordModal
				:productList="productList"
				:productIdList="productIdList"
				:selectedKeyword="selectedKeyword"
				@saveKeywordToCampaign="saveKeywordToCampaign"
				@resetSelectedItem="resetSelectedItem"
				v-if="showRemainingForm"
			></AddCampaignKeywordModal>-->
    <AddCampaignKeywordNewModal
      ref="addCampaignKeywordModal"
      :productList="productList"
      :productIdList="productIdList"
      v-if="showRemainingForm && campaignId && ams_campaign_id"
      :selectedKeyword="selectedKeyword"
      @saveKeywordToCampaign="saveKeywordToCampaign"
      @resetSelectedItem="resetSelectedItem"
      :allKeywordsList="keywordList"
      @isFileOrManual="keywordType"
      :campaignId="campaignId"
      :amsCampaignId="ams_campaign_id"
      :sponseredType="campaignType"
    ></AddCampaignKeywordNewModal>

    <AddCampaignNameConfirmModal
      :campaignName="campaignName"
      @saveCampaign="saveCampaignFinal"
    ></AddCampaignNameConfirmModal>
    <AddCampaignConfirmModal
      @closeModal="navigateToProductList"
      :message="message"
      :header="addCampaignConfirmHeader"
      v-if="openFetchAMSModal"
    ></AddCampaignConfirmModal>
  </div>
</template>

<script>
import AddCampaignKeywordGrid from "@/components/add-campaign/AddCampaignKeywordGrid";
import AddCampaignKeywordModal from "@/components/add-campaign/AddCampaignKeywordModal";
import AddCampaignNameConfirmModal from "@/components/add-campaign/AddCampaignNameConfirmModal";
import AddCampaignConfirmModal from "@/components/add-campaign/AddCampaignConfirmModal";
import CampaignFormDropDown from "@/components/add-campaign/CampaignFormDropDownNew";
import PrestigeEditCampaignTag from "@/components/add-campaign/PrestigeEditCampaignTag.vue"
import ProductListChipView from "@/components/product/ProductListChipView";
import moment from "moment";
import Multiselect from "vue-multiselect";
import AddCampaignKeywordNewModal from "@/components/keyword/AddCampaignKeywordNewModal";
import { environment } from "../../properties.js";
const env = environment;

export default {
  name: "AddCampaignForm",
  data() {
    return {
      minEndDate: "",
      campTagsList: [],
      stopNavigation: false,
      campaignId: "",
      amsCampaignIdFetched: false,
      addCampaignConfirmHeader: "",
      message: "",
      dailyBudget: "",
      campaignType: "",
      campaignTypeList: [
        {
          name: "Sponsored Products",
          id: "Sponsored Products",
        },
        {
          name: "Sponsored Brands",
          id: "Sponsored Brands",
        },
        {
          name: "Sponsored Display",
          id: "Sponsored Display",
        },
      ],
      statusList: [
        {
          name: "Enabled",
          id: "Enabled",
        },
        { name: "Paused", id: "Paused" },
        { name: "Archived", id: "Archived" },
      ],
      state: "",
      campaignName: "",
      productList: [],
      campaignTags: [],
      prestigeTags:{
        brand:[],
        strategy:[],
        country:[],
        segment:[]
      },
      campaignDuration: "option1",
      campaignStartDate: "",
      campaignEndDate: "",
      campaignTargetType: "auto",
      campaignGroup: 0,
      campaignGroupObj: {},
      campaignKeywordList: [],
      keywordList: [],
      selectedKeyword: {},
      newCampaign: {},
      submitted: false,
      productDataList: "",
      todaysDate: "",
      isVendorSelected: false,
      vendorModal: "",
      showVendor: true,
      showisBrandsList: false,
      showisVendorList: false,
      showisProductList: false,
      showRemainingForm: false,
      vendor_id: "",
      brand_id: "",
      todaysDateEditCampaign: "",
      vendor_name: "",
      brand_name: "",
      showRemainingLoader: false,
      showVendorLoader: false,
      showBrandLoader: false,
      showProductLoader: false,
      vendorDropDownList: [],
      brandDropDownList: [],
      productDropDownList: [],
      productIdList: [],
      openFetchAMSModal: false,
      ams_campaign_id: "",
      keywordRetreivalType: "",
      keywordExportCSVData: {},
      keywordGrp: "",
      ams_profile_id: "",
      ams_ad_group_id: "",
      tagSearchLoader: false,
      isAmsProfile: false,
      defaultCampGrpObj: {
        id: 1,
        name: "ORPHAN",
      },
    };
  },
  components: {
    AddCampaignKeywordGrid,
    AddCampaignKeywordModal,
    AddCampaignNameConfirmModal,
    ProductListChipView,
    AddCampaignConfirmModal,
    CampaignFormDropDown,
    moment,
    AddCampaignKeywordNewModal,
    Multiselect,
    PrestigeEditCampaignTag
  },
  computed: {
    selectedProducts() {
      return this.$store.state.product.selectedProducts;
    },
    campaignGroupFilterList: {
      set(val) {
        this.$store.state.campaign.campaignGroupFilterList = val;
      },
      get() {
        if (this.campaignGroup) {
          this.campaignGroupObj = this.$store.state.campaign.campaignGroupFilterList.find(
            (item) => item.id == this.campaignGroup
          );
        }
        return this.$store.state.campaign.campaignGroupFilterList;
      },
    },
    // productListToAdd() {
    //       return this.$store.state.product.productList
    // },
    checkCampaignGroupName() {
      return true;
      if (this.campaignGroup) {
        return true;
      } else {
        return false;
      }
    },
    checkCampaignName() {
      if (this.campaignName || this.campaignName.trim()) {
        return true;
      } else {
        return false;
      }
    },
    checkCampaignType() {
      if (this.campaignType) {
        return true;
      } else {
        return false;
      }
    },
    checkState() {
      if (this.state) {
        return true;
      } else {
        return false;
      }
    },
    checkDailyBudget() {
      if (this.dailyBudget) {
        return true;
      } else {
        return false;
      }
    },
    isEditCampaignPage() {
      if (
        this.$route.params.campaignId &&
        parseInt(this.$route.params.campaignId)
        //	 ||	this.$route.params.products
      ) {
        return true;
      } else {
        return false;
      }
    },
    showLoader: {
      get() {
        return this.$store.getters["getShowLoader"];
      },
    },
    // vendorList(){
    //    	return this.$store.state.vendorList
    // },
    // selectedVendor(){
    // 	   this.isVendorSelected = true
    // 	   let payload = {
    // 		   id : this.selectedVendor
    // 	   }
    // 	   this.$store.dispatch('getAllBrandProfile',{payload})
    //
    // },
    brandList() {
      return this.state.state.brandProfileList;
    },
  },
  watch: {
    campaignStartDate() {
      //this.campaignEndDate = "";
    },
    campaignGroup() {
      if (this.campaignGroup) {
        this.campaignGroupObj = this.campaignGroupFilterList.find(
          (item) => item.id == this.campaignGroup
        );
      }
      if (
        !this.campaignGroupObj &&
        this.campaignGroup &&
        this.campaignGroup == this.defaultCampGrpObj["id"]
      ) {
        this.campaignGroupObj = this.defaultCampGrpObj;
      }
      if (!this.campaignGroup) {
        this.campaignGroupObj = "";
      }
    },
  },
  mounted() {
    this.$store.dispatch("callAnalytics", {
      data: window.location.href,
      this: this,
      type: "AddEditCampaign",
    });

    let vm = this;
    this.searchFromDb();
    const getPrepopulatedData = () => {
      vm.showVendorList(null, (res) => {
        vm.vendorDropDownList = res.filter((e) => e.name);
        if (vm.$route.params.products) {
          vm.productList = vm.$route.params.products.split("+");
        }
        let tempId =
          vm.vendor_id != "" &&
          vm.vendor_id != null &&
          vm.vendor_id != undefined
            ? vm.vendor_id
            : null;
        vm.showBrandFormView(tempId, () => {
          let type = vm.brand_id ? "brand_id" : "";

          vm.showProductsFormView(
            vm.ams_profile_id || vm.brand_id,
            type,
            () => {
              vm.showRemainingForm = true;
              setTimeout(
                () =>
                  vm.$store.commit("hideLoadingSpinner", null, {
                    root: true,
                  }),
                0
              );
            }
          );
        });
      });
    };

    if (
      vm.$route.params.campaignId &&
      parseInt(vm.$route.params.campaignId) > -1
    ) {
      //	vm.showisBrandsList= true;
      //	vm.showisProductList = true;

      vm.showRemainingForm = true;
      let payload = {
        id: parseInt(this.$route.params.campaignId),
        hideLoadingSpinner: true,
      };
      vm.$store.commit("showLoadingSpinner", null, {
        root: true,
      });
      vm.$store.dispatch("campaign/getCampaignById", payload).then((res) => {
        vm.initialiseCampaign(res);
        if (vm.isEditCampaignPage) {
          vm.todaysDateEditCampaign = moment().format("YYYY-MM-DD");
          this.minEndDate = moment().isAfter(moment(this.campaignStartDate))
            ? moment().format("YYYY-MM-DD")
            : moment(this.campaignStartDate).format("YYYY-MM-DD");
          // vm.todaysDateEditCampaign = moment().isAfter(
          // 	moment(vm.campaignStartDate)
          // )
          // 	? moment(vm.campaignStartDate).format("YYYY-MM-DD")
          // 	: moment().format("YYYY-MM-DD");
        }
        getPrepopulatedData();
      });
      // this.$store.dispatch('product/getAllProducts',{callback: (res) => {
      // 	this.productListToAdd = res;
      // }})
    } else {
      if (vm.$route.params.products) {
        let productId = "";
        if (vm.$route.params.products.includes("+")) {
          let list = vm.$route.params.products.split("+");
          productId = list[0];
        } else {
          productId = vm.$route.params.products;
        }
        var payload = {
          productId: productId,
          type: "productId",
        };

        vm.$store.dispatch("product/getProductById", payload).then((res) => {
          vm.vendor_id = res[0].go_vendor_cd;
          vm.brand_id = res[0].profile_id;
          let obj = {
            asin: res[0].asin,
          };
          vm.productList.push(obj);
          vm.isEditCampaignPage = false;
          vm.isAmsProfile = res[0].ams_profile_id ? true : false;
          getPrepopulatedData();
        });
        //	vm.productList = vm.$route.params.products.split("+");
      } else {
        vm.showVendorList(null, (res) => {
          vm.vendorDropDownList = res.filter((e) => e.name);
          vm.$store.commit("hideLoadingSpinner", null, {
            root: true,
          });
        });
      }
    }
  },
  beforeMount() {
    let date = new Date();
    this.todaysDate = moment(date).format("YYYY-MM-DD");
    // if(this.$route.params.products || this.$route.params.campaignId){
    //
    // }
    // else{
    // //	this.$store.dispatch('getAllVendor')
    // }
  },
  methods: {
    setCampGrpId(data) {
      if (data && data.id) {
        this.campaignGroup = data.id;
      }
    },
    removeCampGrpId() {
      this.campaignGroup = "";
    },
    resetCampEndDate() {
      this.campaignEndDate = "";
      this.minEndDate = moment().isAfter(moment(this.campaignStartDate))
        ? moment().format("YYYY-MM-DD")
        : moment(this.campaignStartDate).format("YYYY-MM-DD");
    },
    stopRoute(e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        console.log("Enter");
      }
    },
    searchFromDb(searchText) {
      // if(searchText!=""){
      // 	let payload = {
      // 		q:searchText.toLowerCase()
      // 	}
      this.tagSearchLoader = true;
      const vm = this;
      //since for prestige type campaign we need type specific campaign instead of normal ones
      if(!this.$store.state.isUserPrestige){
        this.$store.dispatch("campaign/getCampTagList", {}).then((res) => {
        vm.campTagsList = res;
        vm.campTagsList = vm.campTagsList.concat(vm.campaignTags);
        vm.tagSearchLoader = false;
      });
      }    

      //}
    },
    selectTagFromList(data) {},
    addTagsGroup(name) {
      //this.campaignTags = ''

      var pay = { title: name, id: "" };
      this.campTagsList.push(pay);
      this.campaignTags.push(pay);
    },
    // resetTagsGrp(option){
    // 	if(option.length)
    // 	{
    // 		this.campaignTags = option[option.length -1]
    // 	}
    // 	else{
    // 		this.campaignTags = ''
    // 	}
    // },
    goToCampaignListPage() {
      this.stopNavigation = false;
      this.navigateToProductList();
    },
    saveKeywordAtBackend() {
      if (
        !this.isEditCampaignPage ||
        this.$route.matched[0].path == "/addEditCampaignProduct/:products"
      ) {
        this.stopNavigation = false;
      } else {
        this.stopNavigation = true;
      }

      this.openFetchAMSModal = true;
      this.message = "Keywords are getting saved!";
      this.addCampaignConfirmHeader = "Saving";
      var payload = {
        ams_campaign_id: this.ams_campaign_id,
        campaign_id: this.campaignId,
        keywords: this.keywordList,
        group_id: this.keywordGrp.id ? this.keywordGrp.id : "",
        count:
          this.keywordGrp && this.keywordGrp.id ? this.keywordGrp.count : "0",
        title: this.keywordGrp.title,
        userName: JSON.parse(window.localStorage.session).name,
        ams_profile_id: env == "PROD" ? this.ams_profile_id : "223797863198027",
        campaign_type: this.campaignType,
        targeting_type: this.campaignTargetType,
        daily_budget: this.dailyBudget,
        start_date_ams: moment(this.startDate).format("YYYYDDMM"),
        campaign_name: this.campaignName,
        grpBid:
          this.keywordGrp && this.keywordGrp.bid ? this.keywordGrp.bid : "",
        ams_ad_group_id: this.ams_ad_group_id ? this.ams_ad_group_id : "",
      };
      payload["keywordRetreivalType"] = this.keywordRetreivalType;
      if (this.keywordRetreivalType == "importFromCsv") {
        payload["keywordExportCSVData"] = this.keywordExportCSVData;
      }
      const vm = this;
      this.$store
        .dispatch("campaign/saveKeywordWithCampaignId", payload)
        .then((res) => {
          if (res) {
            this.message = "Keywords saved!";
            this.addCampaignConfirmHeader = "Saved";
          } else {
            this.message = "Unable to save";
            this.addCampaignConfirmHeader = "Failed";
          }
          //vm.amsCampaignIdFetched = false;
          //vm.navigateToProductList();
        });
    },
    navigateToListPage() {
      if (
        this.$route.params.groupId &&
        parseInt(this.$route.params.groupId) > -1
      ) {
        this.$router.push({
          path: "/campaignList/" + this.$route.params.groupId,
        });
      } else if (
        this.$route.params.campaignId &&
        parseInt(this.$route.params.campaignId) > -1
      ) {
        this.$store.state.calledFromCancel = true;
        this.$router.push({ path: "/campaignList" });
      } else if (
        this.$route.params.products &&
        this.$route.params.products.length > 0
      ) {
        this.$router.push({ path: "/productList" });
      } else if (this.$route.fullPath == "/addEditCampaign") {
        this.$store.state.calledFromCancel = true;
        this.$router.push({ path: "/campaignList" });
      } else {
        this.$router.push({ path: "/campaignList" });
      }
    },
    keywordType(data) {
      this.keywordExportCSVData = data;
      this.keywordRetreivalType = data.keywordAdditiontype;
    },
    fetchKeywords() {
      this.$refs["addCampaignKeywordModal"].fetchKeywordList();
      this.$refs["addCampaignKeywordModal"].getKeywordGroupList();
    },
    setCampaignType(data) {
      this.campaignType = data.name;
    },
    setState(data) {
      this.state = data.name;
    },
    showVendorList(data, callback) {
      //	this.showisVendorList = true;
      this.showisBrandsList = false;
      this.showisProductList = false;
      this.showRemainingForm = false;
      this.fetchVendorList(callback);
    },
    fetchVendorList(callback) {
      const vm = this;
      this.showVendorLoader = true;
      this.$store.dispatch("getAllVendor").then((res) => {
        this.showisVendorList = true;
        // vm.showisVendorList = false;
        // vm.showisVendorList = true;
        vm.showVendorLoader = false;
        callback ? callback.call(vm, res) : "";
      });
    },
    showBrandFormView(data, callback) {
      if (!this.isEditCampaignPage && !this.$route.params.products) {
        this.brand_id = "";
        this.ams_profile_id = "";
        this.brand_name = "";
        if (
          Object.keys(this.$refs).length &&
          this.$refs["multiselectRefBrand"]
        ) {
          this.$refs["multiselectRefBrand"].modalValue = {};
        }
        this.productList = [];
      }
      if (
        (data != 0 && !this.brand_id) ||
        (data != 0 && this.$route.params.products)
      ) {
        this.vendor_id = (data && data.id) || data;
        this.showisBrandsList = true;
        this.showisProductList = false;
        this.showRemainingForm = false;

        this.fetchBrandList((data && data.id) || data, callback);
      } else {
        if (!this.brand_id) {
          this.showisBrandsList = false;
          this.showisProductList = false;
          this.showRemainingForm = false;
        }
        if (this.brand_id && !this.$route.params.products) {
          this.vendor_id = data.id;
        }
      }
    },
    fetchBrandList(vendorId, callback) {
      const vm = this;
      let payload = { vendorId };
      this.showBrandLoader = true;
      this.$store.dispatch("getAllBrandProfile", payload).then((res) => {
        vm.showBrandLoader = false;
        vm.brandDropDownList = res;
        if (vm.brand_id) {
          vm.$refs["multiselectRefBrand"].populateBrand(res, vm.brand_id);
        }
        callback ? callback.call(vm, res) : "";
      });
    },
    getProfileId(amsProfileId) {
      var profileId = this.brandDropDownList.find((brand) => {
        return brand.ams_profile_id == amsProfileId || brand.id == amsProfileId;
      });
      return (profileId || {}).id;
    },
    showProductsFormView(data, type, callback) {
      if (data && type != "brand_id") {
        this.ams_profile_id = (data && data.ams_profile_id) || data;
      }
      if (!this.isEditCampaignPage && !this.$route.params.products) {
        this.productList = [];
      }
      if (data != 0) {
        //this.brand_id = this.brand_id || this.getProfileId(data)
        this.brand_id = this.getProfileId(
          (data && data.ams_profile_id) || data
        );
      }

      if (data != 0) {
        const vm = this;
        //vm.brand_id = data;
        vm.showisProductList = true;
        vm.showProductLoader = true;
        vm.showRemainingForm = true;

        let payload = {
          id: vm.brand_id,
          ams_profile_id: this.ams_profile_id,
          hideLoadingSpinner: true,
        };

        if (this.ams_profile_id && this.isEditCampaignPage) {
          vm.showRemainingForm = true;
        } else {
          vm.showRemainingForm = false;
        }

        vm.$store.dispatch("product/getAllProducts", payload).then((res) => {
          vm.showProductLoader = false;
          vm.showRemainingForm = true;
          callback ? callback.call(vm, res) : "";
        });
      } else {
        this.showisProductList = false;
        this.showRemainingForm = false;
      }

      if (this.ams_profile_id && this.isEditCampaignPage) {
        this.showRemainingForm = true;
        //this.showRemainingFormView;
        this.$store.dispatch("campaign/getCampaignGroupFilterList", {
          // vendor_id: this.vendor_id,
          vendor_id: "",
          ams_profile_id: this.brand_id,
          brand_id: this.ams_profile_id,
        });
      }
    },
    showRemainingFormView(data) {
      let list = [];
      let idList = [];
      if (data.length) {
        list = data.map((res) => {
          return res.asin;
        });
        idList = data.map((res) => {
          return res.id;
        });
        this.productList = list;
        this.productIdList = idList;
        console.log(data);
        this.showRemainingLoader = true;
        this.$store
          .dispatch("campaign/getCampaignGroupFilterList", {
            vendor_id: "",
            ams_profile_id: this.brand_id,
            brand_id: this.ams_profile_id,
          })
          .then((response) => {
            this.showRemainingLoader = false;
            this.showRemainingForm = true;
            $("#campaignTags").attr("autocomplete", "off");
          });
      } else {
        this.productList = [];
        this.productIdList = [];
      }
    },
    resetSelectedItem() {
      this.selectedKeyword = {};
    },
    checkForCampaignName() {
      this.$store.dispatch("campaign/checkExistingCampaignName", {
        data: { campaignName: this.campaignName },
        callback: (response) => {
          console.log(response);
        },
      });
    },
    saveKeywordToCampaign(keyword, keywordGroup, bid, ams_ad_group_id) {
      this.keywordList = keyword;
      this.keywordGrp = keywordGroup;
      this.keywordGrp["bid"] = bid;
      this.ams_ad_group_id = ams_ad_group_id;
      this.saveKeywordAtBackend();
    },
    editSelectedKeyword(keywordIndex) {
      this.selectedKeyword = JSON.parse(
        JSON.stringify(this.keywordList[keywordIndex])
      );
      this.selectedKeyword["keywordIndex"] = keywordIndex;
    },
    deleteSelectedKeyword(keywordIndex) {
      this.keywordList.splice(keywordIndex, 1);
    },
    navigateToProductList() {
      this.openFetchAMSModal = false;
      this.message = false;
      this.addCampaignConfirmHeader = false;

      if (!this.stopNavigation) {
        // 	if (
        // 	!this.isEditCampaignPage &&
        // 	this.campaignTargetType != "auto" &&
        // 	this.amsCampaignIdFetched
        // ) {
        // 	//Don't exit from page, allow user to add keywords first
        // } else
        {
          if (
            this.$route.params.groupId &&
            parseInt(this.$route.params.groupId) > -1
          ) {
            this.$router.push({
              path: "/campaignList/" + this.$route.params.groupId,
            });
          } else if (
            this.$route.params.campaignId &&
            parseInt(this.$route.params.campaignId) > -1
          ) {
            if (
              this.$route.name == "addEditCampaign" &&
              this.isEditCampaignPage
            ) {
              this.$store.state.selectedCampaignGroupFilter = "";
              this.$store.state.selectedBrandProfle = "";
            }
            //window.location.href = '/index.html#/campaignList'
            this.$store.state.currentPageNumber = 1;
            this.$router.push({ path: "/campaignList" });
          } else if (
            this.$route.params.products &&
            this.$route.params.products.length > 0
          ) {
            this.$router.push({ path: "/productList" });
          } else {
            this.$store.state.selectedCampaignGroupFilter = this.campaignGroup;
            this.$router.push({ path: "/campaignList" });
          }
        }
      } else {
        this.stopNavigation = false;
      }
    },
    getDate(dateString) {
      // while (dateString && dateString.indexOf("-") > -1) {
      // 	dateString = dateString.replace("-", "/");
      // }

      dateString = moment(dateString).format("YYYY-MM-DD");
      return dateString;
    },
    getFormattedDate(dateString) {
      if (dateString) {
        let day = moment(dateString, "LL").date();
        let month = moment(dateString, "LL").month() + 1;
        let year = moment(dateString, "LL").year();
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        console.log(year + "-" + month + "-" + day);
        return year + "-" + month + "-" + day;
      } else {
        return null;
      }
    },
    initialiseCampaign(item) {
      // let arr = [];
      // if (item.keywords) {
      // 	item.keywords.map(res => {
      // 		let keyword = JSON.parse(res.keyword);
      // 		let bids = [];
      // 		bids.push({ bid: res.bid, type: res.type });
      // 		let obj = {
      // 			keyword: keyword,
      // 			bids: bids
      // 		};
      // 		// keyword.push(res.keyword);
      // 		// let bids = [];
      // 		// let obj = {
      // 		// 	type: res.type,
      // 		// 	bid: res.bid
      // 		// };
      // 		// bids.push(obj);
      // 		// let finalObj = {
      // 		// 	keyword: keyword,
      // 		// 	bids: bids
      // 		// };
      // 		arr.push(obj);
      // 	});
      // 	this.keywordList = arr;
      // }
      if (item.keywords) {
        this.keywordList = item.keywords;
      }

      if (item.product) {
        this.productDataList = item.product;
      }
      this.state = item.state;
      this.campaignName = item.name;
      if(!this.$store.state.isUserPrestige){
        this.campaignTags = item.tags != "" && item.tags != null && item.tags != "null" && item.tags
          ? JSON.parse(item.tags).map((res) => {
              res.id = res.tag_id;
              return res;
            })
          : [];
      }
      else{
        this.prestigeTags = item.tags != "" && item.tags != null && item.tags != "null" && item.tags ? item.tags : this.prestigeTags
      }
      
        
      //this.campaignTags = item.tags!='null'? item.tags:'';
      //	let temp_date = new Date(item.start_date)
      //	this.campaignStartDate = item.start_date.slice(0,10)
      this.campaignStartDate = moment(item.start_date).format("YYYY-MM-DD");
      this.campaignEndDate = item.end_date
        ? moment(item.end_date).format("YYYY-MM-DD")
        : "";
      this.campaignTargetType = item.targeting_type
        ? item.targeting_type
        : "auto";
      this.campaignGroup = item.campaign_group_id;
      this.productList = item.product;
      this.vendor_id = item.go_vendor_cd;
      this.ams_profile_id = item.ams_profile_id;
      this.brand_id = item.ams_profile_id
        ? this.getProfileId(item.ams_profile_id)
        : "";
      this.vendor_name = item.vendor_name;
      this.brand_name = item.profile_brand_name;
      this.campaignType = item.campaign_type;
      this.state = item.state;
      this.dailyBudget = item.daily_budget;

      this.ams_campaign_id = item.ams_campaign_id;
      this.campaignId = item.id;

      this.isAmsProfile = item.ams_profile_id ? true : false;

      this.showisVendorList = true;

      if (
        this.$route.params.campaignId &&
        parseInt(this.$route.params.campaignId) > -1
      ) {
        this.campaignDuration = "option2";
      } else {
        this.campaignDuration = "option1";
      }
    },

    saveCampaign() {
      this.submitted = true;
      if (!this.checkCampaignName) {
        $("#campaignName").focus();
        return;
      } else if (!this.checkCampaignGroupName) {
        $("#campaignGroup").focus();
        return;
      } else if (!this.dailyBudget) {
        $("#dailyBudget").focus();
        return;
      } else if (!this.$refs["selectState"].validate()) {
        return;
      } else if (!this.$refs["selectCampaignType"].validate()) {
        return;
      } else {
        let vm = this;
        this.newCampaign = {};
        // if (this.productDataList) {
        // 	let list = [];
        // 	list.push(this.productDataList);
        // 	this.newCampaign["products"] = list;
        // }
        this.newCampaign["name"] = this.campaignName;
        if (this.productIdList && this.productIdList.length > 0) {
          this.newCampaign["products"] = this.productList;
        }
        this.newCampaign["tags"] = this.campaignTags;
        if (this.campaignDuration == "option2") {
          this.newCampaign["startDate"] = this.getDate(this.campaignStartDate);
          this.newCampaign["endDate"] = this.getDate(this.campaignEndDate);
        } else {
          let date = new Date();
          this.newCampaign["startDate"] =
            date.getUTCFullYear() +
            "/" +
            (date.getUTCMonth() + 1) +
            "/" +
            date.getUTCDate();
          this.newCampaign["endDate"] = null;
        }
        this.newCampaign["brand_id"] = this.brand_id;
        this.newCampaign["vendor_id"] = this.vendor_id;
        this.newCampaign["targetingType"] = this.campaignTargetType;
        this.newCampaign["campaignGroup"] = this.campaignGroup;
        this.newCampaign["campaignType"] = this.campaignType;
        this.newCampaign["dailyBudget"] = this.dailyBudget;
        this.newCampaign["state"] = this.state;
        this.newCampaign["ams_campaign_id"] = this.ams_campaign_id;
        this.newCampaign["ams_profile_id"] =
          this.ams_profile_id ||
          (this.getAmsProfileId(this.brand_id) || {}).ams_profile_id;
        this.newCampaign["keywordRetreivalType"] = this.keywordRetreivalType;
        if (this.keywordRetreivalType == "importFromCsv") {
          this.newCampaign["keywordExportCSVData"] = this.keywordExportCSVData;
        }
        // if (this.keywordList && this.keywordList.length) {
        // 	this.keywordList.forEach(element => {
        // 		if (element.keywordIndex > -1) {
        // 			delete element.keywordIndex;
        // 		}
        // 	});
        // }
        // let arr = [];
        // this.keywordList.map(key => {
        // 	// //
        // 	key.bids.map(res => {
        // 		let obj = {
        // 			bid: res.bid,
        // 			type: res.type,
        // 			keyword: key.keyword[0]
        // 		};
        // 		arr.push(obj);
        // 	});
        // });

        if (
          this.$route.params.campaignId &&
          parseInt(this.$route.params.campaignId) > -1
        ) {
          this.newCampaign["id"] = parseInt(this.$route.params.campaignId);
          this.newCampaign["keywords"] = this.keywordList;
        }
        this.openFetchAMSModal = true;
        this.message =
          "Campaign is getting saved! Don't refresh or press the close button";
        this.addCampaignConfirmHeader = "Saving";

        //check if selected brand is part of brand list or not
        let profileIndex = this.brandDropDownList.find(
          (item) => item.id == vm.brand_id
        );
        this.newCampaign["showBrand"] = profileIndex ? true : false;
  
        if(this.$store.state.isUserPrestige){
          this.newCampaign["isUserPrestige"] = true;
          this.newCampaign["tags"] = this.$refs.editPrestigeTag.submit();
        }
        this.$store.dispatch("campaign/saveNewCampaign", {
          data: this.newCampaign,
          callback: (res) => {
            if (
              !vm.isEditCampaignPage ||
              vm.$route.matched[0].path == "/addEditCampaignProduct/:products"
            ) {
              vm.addCampaignConfirmHeader = "Syncing";
              vm.message =
                "Campaign has been saved. Syncing Ams id! Don't refresh or press the close button";
              vm.fetchAmsCampaignIdLogic(res);
            } else {
              vm.addCampaignConfirmHeader = "Success";
              vm.message = "Campaign has been saved successfully!";
            }
          },
        });
      }
    },
    getAmsProfileId(brandId) {
      var amsProfileId = this.brandDropDownList.find((brand) => {
        return brand.id == brandId;
      });

      return amsProfileId;
    },
    fetchAmsCampaignIdLogic(res) {
      const vm = this;
      //var amsProfileId = this.getAmsProfileId(res.brand_id);
      this.ams_profile_id = res.ams_profile_id;
      //this.ams_profile_id = amsProfileId.ams_profile_id
      var pay = {
        name: res.name,
        targeting_type: res.targetingType,
        state: res.state,
        daily_budget: res.dailyBudget,
        start_date_ams: moment(res.startDate).format("YYYYDDMM"),
        ams_profile_id: this.ams_profile_id,
        campaign_type: res.campaignType,
      };
      this.$store
        .dispatch("campaign/fetchAmsCampaignId", pay)
        .then((response) => {
          if (response.ams_campaign_id) {
            vm.addCampaignConfirmHeader = "Success";
            vm.message = "Ams has been fetched successfully!";
            vm.amsCampaignIdFetched = true;
            (vm.campaignId = res.id),
              (vm.ams_campaign_id = response.ams_campaign_id);
            vm.saveAmsAtBackend({
              campaignId: res.id,
              amsCampaignId: response.ams_campaign_id,
            });
            if (vm.campaignTargetType != "auto") {
              vm.stopNavigation = true;
            }
          } else {
            vm.stopNavigation = false;
            vm.message = " Syncing Ams id failed !";
            let data = {
              campaignId: res.id,
            };
            this.$store
              .dispatch("campaign/sendMailForNoAms", data)
              .then((mailSent) => {
                console.log(mailSent);
              });
          }
        });
    },
    saveAmsAtBackend(data) {
      const vm = this;
      this.addCampaignConfirmHeader = "Saving";
      this.message = "Saving AMS id! Don't refresh or press the close button";

      this.$store
        .dispatch("campaign/saveAmsCampaignId", data)
        .then((response) => {
          vm.addCampaignConfirmHeader = "Success";
          vm.message = "Ams has been saved successfully!";
        });
    },
    saveCampaignFinal() {
      let profileIndex = this.brandDropDownList.find(
        (item) => item.id == vm.brand_id
      );
      this.newCampaign["showBrand"] = profileIndex ? true : false;

      this.$store.dispatch("campaign/saveNewCampaign", {
        data: this.newCampaign,
        callback: () => {
          //$('#confirmAddCampaign').modal('show')
          this.openFetchAMSModal = true;
          //this.navigateToProductList();
        },
      });
    },
    checkForDuration() {
      console.log(this.campaignDuration);
    },
  },
};
</script>

<style lang="scss">
.campaign-tags-add {
  .multiselect__single {
    text-transform: none !important;
    overflow: hidden;
  }
}
.campaign-tags-add {
  .multiselect__option span {
    text-transform: none !important;
  }
}
.campaign-tags-add {
  .multiselect__tag {
    text-transform: none !important;
  }
}
</style>
